/* eslint-disable no-custom-animation/no-custom-animation */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */

import {
	Avatar,
	Box,
	// eslint-disable-next-line no-restricted-imports
	Button,
	createStyles,
	Flex,
	Group,
	Loader,
	Modal,
	rem,
	Stack,
	Tooltip,
	UnstyledButton,
	useMantineTheme,
} from '@mantine/core';
import type { FloatingPosition } from '@mantine/core/lib/Floating';
import { DatePicker, type DateValue } from '@mantine/dates';
import { useDisclosure } from '@mantine/hooks';
import { Prism } from '@mantine/prism';
import type {
	AnalyticsMetricType,
	ApiCheckIamPermissionQueryParams,
	DataQualityScore,
	JoinConditionOperator,
	JoinKind,
	JoinMethod,
	JoinSide,
	LiteUser,
	MetricType,
	PermissionType,
	PolicyOut,
	TeamOut,
} from '@repo/api-codegen';
import { fetchApiCheckIamPermission } from '@repo/api-codegen';
import { useApiListTeamsV2 } from '@repo/api-codegen/v2';
import IconEmojiSelector from '@repo/common/components/IconEmojiSelector/IconEmojiSelector.tsx';
import { iconEmojiSelectorValueToString } from '@repo/common/components/IconEmojiSelector/utils';
import MarkdownRenderer from '@repo/common/components/MarkdownRenderer';
import RichTooltip from '@repo/common/components/RichTooltip/RichTooltip.tsx';
import { SELECTABLE_PROPERTY_OPTIONS } from '@repo/common/components/SelectableProperty/constants.ts';
import SingleSelector from '@repo/common/components/SingleSelector/SingleSelector.js';
import type { SelectablePropertyItem } from '@repo/common/components/SingleSelector/types.js';
import {
	colorGroupToFillMap,
	getUserInitialsFromName,
} from '@repo/common/components/UserAvatar/helpers.ts';
import { EntityType } from '@repo/common/enums/entityType';
import { pickColorType } from '@repo/common/utils';
import { getBreadCrumbsFromSearchMetadata } from '@repo/common/utils/breadcrumb.ts';
import {
	Badge,
	Banner,
	Icon,
	IconButton,
	NumberInput,
	Text,
	type BadgeVariant,
} from '@repo/foundations';
import type { ColorNames } from '@repo/theme/utils.ts';
import { useUpdateEffect } from 'ahooks';
import dayjs from 'dayjs';
import { isEmpty } from 'lib0/object';
import {
	capitalize,
	filter,
	get,
	isArray,
	isNil,
	lowerCase,
	map,
	size,
	startCase,
} from 'lodash-es';
import type { ReactNode } from 'react';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import {
	useCurrentTeamMemberships,
	useTeamPermission,
} from '../../api/hooks/team/myMemberships.tsx';
import { useExtendedUserList } from '../../api/hooks/user/useExtendedUserList.ts';
import type {
	Automation,
	IBaseModel,
	ICollection,
	IIntegration,
	ILineage,
	ISearchMetadata,
	ISecodaEntity,
	ITag,
	IUser,
	IUserGroup,
} from '../../api/index.ts';
import {
	useAuthUser,
	useIntegrationPrefetched,
	useUpdateSecodaEntity,
} from '../../api/index.ts';
import {
	CUSTOM_PROPERTY_COLUMN_PREFIX,
	NEW_CUSTOM_PROPERTY_COLUMN_PREFIX,
} from '../../constants.ts';
import type { SecodaEntity } from '../../lib/models/index.ts';
import { getEntityDisplayTitle } from '../../lib/utils/entity.ts';
import { INTEGRATION_STATUS_MAPPING } from '../../pages/IntegrationsPage/constants.ts';
import { mapEntityTypeToIcon } from '../../utils/integrationLogo.tsx';
import { entityUrl } from '../../utils/navigationUtils.ts';
import { snakeCaseToTitleCase } from '../../utils/shared.utils.ts';
import { formatShortTimeDifference, getEpoch } from '../../utils/time.ts';
import { isJson } from '../../utils/utils.ts';
import { MonitorIcon } from '../AddMonitorV2/MonitorIcon/MonitorIcon';
import DistributionPopup from '../CatalogView/TableView/components/DistributionPopup/index.ts';
import { DateRenderer } from '../CatalogView/TableView/DateRenderer.tsx';
import ColumnProfile from '../ColumnProfile/ColumnProfile.tsx';
import { DataQualityBadgeWithHover } from '../DataQualityScore/DataQualityBadgeWithHover.tsx';
import DescriptionEditor from '../DescriptionEditor';
import { CollectionSelector } from '../EntityModal/Metadata/CollectionSelector.tsx';
import { OptimizedRelatedEntitiesRender } from '../EntityModal/Metadata/OptimizedRelatedEntitiesRender';
import { OwnerSelector } from '../EntityModal/Metadata/OwnerSelector.tsx';
import RelatedEntitiesSelector from '../EntityModal/Metadata/RelatedEntitiesSelector';
import { StaticProperty } from '../EntityPageLayout/EntityPropertySidebar/index.ts';
import IntegrationLogo from '../IntegrationLogo/index.tsx';
import { closeModal } from '../ModalManager';
import type { PropertySelectorProps } from '../Properties/PropertySelector.tsx';
import { PropertySelector } from '../Properties/PropertySelector.tsx';
import TagPropertySelector from '../Properties/TagPropertySelector.tsx';
import { nFormatter } from '../SearchListItem/helpers.ts';
import { Popularity } from '../SearchListItem/template.tsx';
import { SynonymsSelector } from '../SynonymSelector/SynonymsSelector.tsx';
import { UserAvatar } from '../UserAvatar/index.ts';
import { OptimizedCollectionRender } from './OptimizedCollectionRender';
import { OptimizedDatePickerRender } from './OptimizedDatePickerRender';
import { OptimizedDescriptionRender } from './OptimizedDescriptionRender';
import { OptimizedNumberRender } from './OptimizedNumberRender';
import { OptimizedOwnerRender } from './OptimizedOwnerRender';
import { OptimizedSelectorRender } from './OptimizedSelectorRender';
import { OptimizedTagRender } from './OptimizedTagRender';
import { ROW_HEIGHT } from './TableV2.styles.ts';
import { extractTagIds } from './tagUtils';

const useStyles = createStyles(
	(
		theme,
		{ level = 0, readOnly = false }: { level?: number; readOnly?: boolean }
	) => {
		const hoverFillColor = 'fill/transparent/hover';
		const activeFillColor = 'fill/transparent/active';
		const hoverIconColor: ColorNames = 'icon/primary/hover';
		const paddingY: number = theme.other.space[1.5];
		const activeIconColor: ColorNames = 'icon/primary/active';
		const boxShadow = '';
		const boxShadowOnActive = '';

		return {
			ellipsis: {
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
			},
			titleGroup: {
				flexWrap: 'nowrap',
				minHeight: ROW_HEIGHT,
				marginLeft: level * 20,
				padding: `${theme.spacing.sm} 0`,
			},
			container: {
				height: theme.other.space[7],
				width: theme.other.space[7],
				flexShrink: 0,
				padding: `${paddingY} 0`,
				marginRight: theme.spacing['xs'],
				position: 'relative',

				borderRadius: theme.other.space[2],

				boxShadow: boxShadow,
				transition: 'box-shadow 0.075s ease-in-out 0s',

				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',

				...(readOnly
					? {}
					: {
							'&:hover': {
								color: theme.other.getColor(hoverIconColor),
								backgroundColor: theme.other.getColor(hoverFillColor),
							},
							'&:active': {
								color: theme.other.getColor(activeIconColor),
								backgroundColor: theme.other.getColor(activeFillColor),
								boxShadow: boxShadowOnActive,
								paddingTop: undefined,
								paddingBottom: undefined,
							},
							'&:focus': {
								outline: `solid ${theme.other.getColor('border/emphasis/default')} 2px`,
								outlineOffset: rem(theme.other.space[0.25]),
							},
						}),
			},
		};
	}
);

const iconSize = 24;

interface PermissionWrapperProps {
	entity: {
		id: string;
		entity_type?: string | EntityType;
		owners?: string[];
		current_user_permissions?: {
			write: boolean;
		};
	};
	objectType?: ApiCheckIamPermissionQueryParams['object_type'];
	v2Permission?: PermissionType;
	children: (props: {
		hasPermission: boolean | null;
		isCheckingPermission: boolean;
	}) => ReactNode;
	onClick?: () => void;
	disabled?: boolean;
	className?: string;
	style?: React.CSSProperties;
}

export function PermissionWrapper({
	entity,
	objectType,
	v2Permission = 'Resources.Update',
	children,
	onClick,
	disabled = false,
	className,
	style,
}: PermissionWrapperProps) {
	const [isCheckingPermission, setIsCheckingPermission] = useState(false);
	const [hasPermission, setHasPermission] = useState<boolean | null>(null);
	const theme = useMantineTheme();

	const handleClick = useCallback(async () => {
		if (disabled) return;

		// If we already know we don't have permission, don't proceed
		if (hasPermission === false) return;

		// If we already know we have permission, proceed immediately
		if (hasPermission === true) {
			onClick?.();
			return;
		}

		// Check permission with loading state
		setIsCheckingPermission(true);

		try {
			// The permission check is synchronous, but we add a small delay
			// to show the loading state and make the UX feel more responsive
			await new Promise((resolve) => setTimeout(resolve, 100));

			// Call the API to check permission
			const result = await fetchApiCheckIamPermission({
				queryParams: {
					permission: v2Permission,
					object_id: entity.id,
					...(objectType ? { object_type: objectType } : {}),
				},
			});

			if (result.ok) {
				setHasPermission(true);
				onClick?.();
			} else {
				setHasPermission(false);
			}
		} catch {
			// If there's an error, assume no permission
			setHasPermission(false);
		} finally {
			setIsCheckingPermission(false);
		}
	}, [disabled, onClick, hasPermission, entity.id, objectType, v2Permission]);

	// Determine if the component should be disabled/readonly
	const isDisabled =
		disabled || isCheckingPermission || hasPermission === false;

	return (
		<Box
			className={className}
			style={{
				position: 'relative',
				...style,
			}}
		>
			{isCheckingPermission && (
				<Box
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						backgroundColor: theme.other.getColor('surface/glass/ultrathick'),
						borderRadius: theme.radius.sm,
						zIndex: 1,
					}}
				>
					<Loader
						size="xs"
						color={theme.other.getColor('icon/primary/default')}
					/>
				</Box>
			)}
			<Box
				onClick={handleClick}
				style={{
					cursor: isDisabled ? 'not-allowed' : 'pointer',
					opacity: isDisabled ? 0.6 : 1,
					pointerEvents: isDisabled ? 'none' : 'auto',
				}}
			>
				{children({ hasPermission, isCheckingPermission })}
			</Box>
		</Box>
	);
}

export function CapitalizeTextRender<T extends ISecodaEntity | ILineage>({
	record,
	field,
	field2,
}: {
	record: T;
	field: keyof T;
	field2: keyof T;
}) {
	const { classes } = useStyles({});

	let value = get(record, field) ?? get(record, field2) ?? 'None';
	value = startCase(String(value));

	return (
		<Text
			size="sm"
			role="link"
			sx={{
				lineHeight: `${ROW_HEIGHT}px`,
			}}
			className={classes.ellipsis}
			color="text/primary/default"
		>
			{isEmpty(value) ? ' ' : value}
		</Text>
	);
}

export function BoldTextRender<T extends IBaseModel>({
	record,
	field,
}: {
	record: T;
	field: keyof T;
}) {
	const { classes } = useStyles({});

	return (
		<Text
			size="sm"
			role="link"
			weight="bold"
			className={classes.ellipsis}
			color="text/primary/default"
			sx={{
				lineHeight: `${ROW_HEIGHT}px`,
			}}
		>
			{isEmpty(get(record, field) as unknown as object)
				? 'Untitled'
				: (get(record, field) as ReactNode)}
		</Text>
	);
}

export function TextRender<T extends IBaseModel>({
	record,
	field,
}: {
	record: T;
	field: keyof T;
}) {
	const { classes } = useStyles({});

	const value = get(record, field);
	return (
		<Text
			size="sm"
			role="link"
			sx={{
				lineHeight: `${ROW_HEIGHT}px`,
			}}
			className={classes.ellipsis}
			color="text/primary/default"
		>
			{isEmpty(value as unknown as object) && typeof value !== 'number'
				? ''
				: (value as ReactNode)}
		</Text>
	);
}

export function TitleRender({
	record,
	modalId,
	forceReadOnly = false,
	showDescription = false,
}: {
	record: {
		id: string;
		entity_type?: EntityType;
		title?: string;
		title_cased?: string;
		description?: string;
		icon?: string;
		search_metadata?: ISearchMetadata;
		onExpandClick?: (id: string) => void;
		onLoadMore?: (id: string) => void;
		paramExpandedParentPrefix?: string;
		paramExpandedLevel?: number;
		paramExpanded?: boolean;
		isLastElement?: boolean;
	};
	modalId?: string;
	forceReadOnly?: boolean;
	showDescription?: boolean;
}) {
	const {
		onExpandClick,
		id,
		paramExpanded,
		paramExpandedLevel,
		isLastElement,
		onLoadMore,
	} = record;
	const level = paramExpandedLevel ?? 0;

	const { isEditorUser } = useAuthUser();
	const readOnly = forceReadOnly || !isEditorUser;

	const { classes } = useStyles({ level, readOnly });

	const navigate = useNavigate();
	const theme = useMantineTheme();

	const [expanded, setExpanded] = useState(paramExpanded ?? false);

	const textRef = useRef<HTMLDivElement>(null);

	const handleNavigate = useCallback(
		(e: React.MouseEvent) => {
			!readOnly && e.stopPropagation();
			!readOnly && e.preventDefault();

			const url = entityUrl(record as unknown as SecodaEntity);

			if (modalId) {
				closeModal(modalId);
			}

			// If holding the `meta` key, open the entity in a new tab.
			if (e.metaKey) {
				window.open(url, '_blank');
			} else {
				navigate(url);
			}
		},
		[modalId, navigate, record, readOnly]
	);

	const isEllipsisHidden = useCallback(
		(e: HTMLDivElement | null) => (e ? e.offsetWidth >= e.scrollWidth : false),
		[]
	);

	const { mutateAsync: updateEntity } = useUpdateSecodaEntity({});

	const handleIconChange = useCallback(
		async (value: string) => {
			await updateEntity({
				data: {
					id: record.id,
					['icon']: value,
				},
			});
		},
		[record, updateEntity]
	);

	const tooltipLabel = useMemo(() => getEntityDisplayTitle(record), [record]);

	const entityTypesWithIcon = [
		EntityType.collection,
		EntityType.document,
		EntityType.dictionary_term,
		EntityType.glossary,
		EntityType.bi_dashboard,
	];
	const defaultIcon = mapEntityTypeToIcon(record.entity_type)
		? iconEmojiSelectorValueToString(mapEntityTypeToIcon(record.entity_type)!)
		: '';
	const shouldRenderDefaultIcon =
		!record.icon &&
		defaultIcon &&
		entityTypesWithIcon.includes(record.entity_type as EntityType);
	const shouldRenderIcon = record.icon && !record.icon.includes('.svg');

	return (
		<Group
			pos="relative"
			data-testid="title-render"
			spacing={0}
			className={classes.titleGroup}
		>
			{onExpandClick ? (
				<Box
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
					}}
				>
					<IconButton
						tooltip={expanded ? 'Hide children' : 'Show children'}
						tooltipProps={{ withinPortal: true }}
						style={{
							transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
							transition: 'transform 0.2s ease',
						}}
						iconName="chevronRight"
						variant="tertiary"
						onClick={() => {
							setExpanded((prev) => !prev);
							onExpandClick(id);
						}}
						data-testid="toggle-expand-button"
					/>
				</Box>
			) : (
				<Box
					w={theme.other.space[7]}
					style={{ display: 'inline-block', flexShrink: 0 }}
				/>
			)}
			<Box>
				{(shouldRenderIcon || shouldRenderDefaultIcon) && (
					<Box
						className={classes.container}
						onClick={(e) => {
							!readOnly && e.stopPropagation();
							!readOnly && e.preventDefault();
						}}
					>
						<IconEmojiSelector
							value={record.icon ?? defaultIcon}
							onChange={handleIconChange}
							iconSize={15}
							emojiSize={15}
							entityType={record.entity_type}
							readOnly={readOnly}
						/>
					</Box>
				)}
			</Box>
			{/* If we are expandable, `navigate` is set to false in the coldef
			 and we need to handle clicks on the title directly. */}
			<Box
				display="flex"
				h="100%"
				w="100%"
				onClick={handleNavigate}
				sx={{
					overflow: 'hidden',
				}}
			>
				<Tooltip
					maw={theme.other.space[90]}
					sx={{
						overflowWrap: 'break-word',
						whiteSpace: 'normal',
					}}
					zIndex={1000}
					withinPortal
					position="top"
					pos="absolute"
					label={tooltipLabel}
					hidden={
						isEmpty(record?.title_cased ?? record?.title) ||
						isEllipsisHidden(textRef.current)
					}
				>
					<Stack spacing={0} maw="100%" sx={{ overflow: 'hidden' }}>
						<Text
							size="sm"
							role="link"
							ref={textRef}
							className={classes.ellipsis}
							color="text/primary/default"
							fw="bold"
						>
							{getEntityDisplayTitle(record)}
						</Text>
						{showDescription && record.description && (
							<Text size="xs" color="text/secondary/default" lineClamp={1}>
								{record.description}
							</Text>
						)}
					</Stack>
				</Tooltip>
			</Box>
		</Group>
	);
}

export function ReadOnlyFormSubmissionStatusRender(record: { status: string }) {
	const status = record?.status;
	return (
		<Badge
			variant={status?.toLowerCase() === 'approved' ? 'success' : 'default'}
		>
			{status}
		</Badge>
	);
}

export function SingleOwnerRender({
	record,
}: {
	record: {
		user?: IUser | LiteUser | undefined | null;
	};
}) {
	const user = record?.user;
	const { classes } = useStyles({});

	if (!user) {
		return null;
	}

	return (
		<Group spacing="xs">
			<UserAvatar size="xxs" user={user as IUser} />
			<Text size="sm" className={classes.ellipsis}>
				{user?.display_name}
			</Text>
		</Group>
	);
}

export function ReadOnlyOwnersRender({
	owners,
	suffix,
	showTooltip = false,
}: {
	owners?: IUser[];
	suffix?: string;
	showTooltip?: boolean;
}) {
	const { classes } = useStyles({});

	const tooltipDisplayed = useMemo(
		() => showTooltip && owners && owners.length && owners.length > 1,
		[owners, showTooltip]
	);

	const tooltipBody = useMemo(
		() => (
			<Stack spacing={'xs'}>
				{map(owners, (user) => (
					<Group key={user.id} spacing="xs" noWrap>
						<UserAvatar size="sm" user={user} />
						<Text size="sm" className={classes.ellipsis}>
							{user.display_name}
						</Text>
					</Group>
				))}
			</Stack>
		),
		[owners, classes.ellipsis]
	);

	return (
		<RichTooltip hidden={!tooltipDisplayed} body={tooltipBody}>
			<Group spacing="xs" noWrap>
				<Avatar.Group spacing="xs">
					{map(owners, (user) => (
						<UserAvatar size="sm" user={user} />
					))}
				</Avatar.Group>
				<Text size="sm" className={classes.ellipsis}>
					{size(owners) === 1 && owners?.[0].display_name}
					{size(owners) > 1 && `${owners?.length} people`}
					{suffix && (
						<Text
							size="sm"
							color="text/secondary/default"
							span
						>{` ${suffix}`}</Text>
					)}
				</Text>
			</Group>
		</RichTooltip>
	);
}

export function ReadOnlyGroupsRender({ groups }: { groups?: IUserGroup[] }) {
	const { classes } = useStyles({});

	const display_name = groups?.[0]?.name;
	const theme = useMantineTheme();
	const colorGroup = pickColorType(display_name);
	const { fillStart, fillEnd, textColor } = colorGroupToFillMap(colorGroup);
	const initials = getUserInitialsFromName(display_name) || '';

	return (
		<Group spacing={'xs'} noWrap>
			<Avatar.Group spacing="xs">
				{map(groups, (group) => (
					<Avatar
						key={group.id}
						size={iconSize}
						h={iconSize}
						w={iconSize}
						mih={iconSize}
						miw={iconSize}
						sx={{
							backgroundImage: theme.fn.gradient({
								from: fillStart,
								to: fillEnd,
								deg: 180,
							}),
							color: textColor,
						}}
					>
						{initials}
					</Avatar>
				))}
			</Avatar.Group>
			<Text size="sm" className={classes.ellipsis}>
				{size(groups) === 1 && groups?.[0].name}
				{size(groups) > 1 && `${groups?.length} groups`}
			</Text>
		</Group>
	);
}

export function ReadOnlyOwnersIdsRender<T>({
	record,
	accessor,
}: {
	record: T;
	accessor: keyof T;
}) {
	const { activeUsers } = useExtendedUserList();
	const owners =
		activeUsers?.filter((user) => get(record, accessor)?.includes(user.id)) ??
		[];

	return <ReadOnlyOwnersRender owners={owners as IUser[]} />;
}

export function UserRender<T>({
	record,
	accessor,
	esAccessor,
}: {
	record: T;
	accessor: keyof T;
	esAccessor?: keyof T;
}) {
	const value = get(record, accessor) ?? get(record, esAccessor ?? accessor);

	const { activeUsers } = useExtendedUserList();
	const owners = activeUsers?.filter((user) => value === user.id) ?? [];

	return <ReadOnlyOwnersRender owners={owners} />;
}

export function UsersAndGroupsRender<T>({
	record,
	userAccessor,
	userEsAccessor,
	groupAccessor,
	groupEsAccessor,
}: {
	record: T;
	userAccessor: keyof T;
	userEsAccessor: keyof T;
	groupAccessor: keyof T;
	groupEsAccessor: keyof T;
}) {
	const userValue = get(record, userAccessor) ?? get(record, userEsAccessor);
	const groupValue = get(record, groupAccessor) ?? get(record, groupEsAccessor);

	const { activeUsers, userGroups } = useExtendedUserList();
	const owners = activeUsers?.filter((user) => userValue === user.id) ?? [];
	const groups = userGroups?.filter((group) => groupValue === group.id) ?? [];

	return (
		<>
			{groups.length > 0 ? (
				<ReadOnlyGroupsRender groups={groups} />
			) : (
				<ReadOnlyOwnersRender owners={owners} />
			)}
		</>
	);
}

export function ColumnProfileRender(record: {
	title: string;

	search_metadata: {
		type: string;
		isPrimaryKey: boolean;
	};

	type: string;

	profile_data: {
		count: number;
		max: number;
		median: number;
		unique: number;
		percent_filled: number;
		min: number;
		mean: number;
		ntiles: {
			is_numeric: boolean;
			left: number;
			right: number;
			label: string;
			frequency: number;
		}[];
	} | null;
}) {
	const [opened, { close, open }] = useDisclosure(false);

	if (!record.profile_data) {
		return null;
	}

	return (
		<>
			{opened && (
				<DistributionPopup
					fieldName={record.title}
					opened={opened}
					onClose={close}
					profileData={record.profile_data}
					columnType={get(record, 'search_metadata.type')}
					isPrimaryKey={get(record, 'search_metadata.is_pk') ?? false}
				/>
			)}
			<Group onClick={open}>
				<ColumnProfile data={record?.profile_data?.ntiles} />
			</Group>
		</>
	);
}

export type TagRenderProps<T> = {
	onChange?: (id: string) => (value: string[]) => void;
	field?: string;
	record: T;
	recordType?: ApiCheckIamPermissionQueryParams['object_type'];
	label?: string;
	hideOnEmpty?: boolean;
	customPropertyIdFilter?: string;
	readOnly?: boolean;
	v2Permission?: PermissionType;
	position?: FloatingPosition;
	withinPortal?: boolean;
};

export function TagRender<
	T extends { id: string; integration?: string; tags?: string[] | ITag[] },
>({
	onChange,
	field = 'tags',
	record,
	recordType,
	label,
	hideOnEmpty = true,
	customPropertyIdFilter,
	readOnly = false,
	v2Permission = 'Resources.Update',
	position,
	withinPortal,
}: TagRenderProps<T>) {
	const theme = useMantineTheme();
	const { id, integration: integrationId } = record;

	const { data: integration } = useIntegrationPrefetched({
		id: integrationId!,
		options: { enabled: !!integrationId },
	});

	const forceSourceTags = !!integration?.force_source_tags;

	const tagIds = useMemo(() => extractTagIds(record, field), [field, record]);

	const handleTagChange = useCallback(
		(value: string[]) => {
			onChange?.(id)(value);
		},
		[id, onChange]
	);

	return (
		<PermissionWrapper
			entity={record}
			objectType={recordType}
			v2Permission={v2Permission}
			disabled={readOnly}
		>
			{({ hasPermission }) => {
				// Use lightweight read-only display when no permission
				if (hasPermission !== true || !onChange || readOnly) {
					return (
						<Box ml={`-${theme.spacing['2xs']}`}>
							<OptimizedTagRender
								field={field}
								record={record}
								label={label}
								hideOnEmpty={hideOnEmpty}
								customPropertyIdFilter={customPropertyIdFilter}
							/>
						</Box>
					);
				}

				// Use full TagPropertySelector when user has permission
				return (
					<Box ml={`-${theme.spacing['2xs']}`}>
						<TagPropertySelector
							customPropertyIdFilter={customPropertyIdFilter}
							label={label}
							key={tagIds.join('-')}
							hideOnEmpty={hideOnEmpty}
							field={field}
							readOnly={readOnly || isNil(onChange) || forceSourceTags}
							onChange={handleTagChange}
							placeholder={
								readOnly || forceSourceTags
									? `No ${label ?? field}`
									: `Add ${label ?? field}`
							}
							forceVariant="tertiary"
							initialValue={tagIds}
							forceSourceTags={forceSourceTags}
							entityIntegrationId={integrationId}
							defaultOpened={true}
							position={position}
							withinPortal={withinPortal}
						/>
					</Box>
				);
			}}
		</PermissionWrapper>
	);
}

export function ParentRenderer({
	record,
}: {
	record: { search_metadata?: ISearchMetadata };
}) {
	const { search_metadata: searchMetadata } = record;
	const breadcrumbs = getBreadCrumbsFromSearchMetadata(searchMetadata);

	const { classes, theme } = useStyles({});

	const textRef = useRef<HTMLDivElement>(null);

	const isEllipsisHidden = useCallback(
		(e: HTMLDivElement | null) => (e ? e.offsetWidth >= e.scrollWidth : false),
		[]
	);

	return (
		<Tooltip
			maw={theme.other.space[90]}
			sx={{
				overflowWrap: 'break-word',
				whiteSpace: 'normal',
			}}
			withinPortal
			hidden={isEllipsisHidden(textRef.current)}
			label={breadcrumbs.join(' / ')}
		>
			<Text size="sm" ref={textRef} className={classes.ellipsis}>
				{breadcrumbs.join(' / ')}
			</Text>
		</Tooltip>
	);
}

export function OwnerRender<
	T extends Pick<
		ISecodaEntity,
		'owners' | 'owners_groups' | 'id' | 'integration'
	>,
>({
	label = 'owners',
	field = 'owners',
	ownerGroupField = 'owners_groups',
	record,
	onChangeUserOwners,
	onChangeGroupOwners,
	hideOnEmpty = true,
	forceReadOnly = false,
	placeholder,
	position,
	withinPortal,
}: {
	label?: string;
	field?: string;
	ownerGroupField?: string;
	record: T;
	onChangeUserOwners?: (id: string) => (value: string[]) => void;
	onChangeGroupOwners?: (id: string) => (value: string[]) => void;
	hideOnEmpty?: boolean;
	forceReadOnly?: boolean;
	placeholder?: string;
	position?: FloatingPosition;
	withinPortal?: boolean;
}) {
	const theme = useMantineTheme();
	const { members } = useCurrentTeamMemberships();
	const { id, integration: integrationId } = record;

	// Handle the case where the field value is a stringified array, which is the
	// case for custom properties.

	const _owners =
		(isJson(get(record, field))
			? JSON.parse(get(record, field))
			: get(record, field)) ?? [];
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const owners = isArray(_owners) ? _owners : [];

	// Handle the case where the field value is a stringified array, which is the
	// case for custom properties.

	const _owners_groups =
		(isJson(get(record, ownerGroupField))
			? JSON.parse(get(record, ownerGroupField))
			: get(record, ownerGroupField)) ?? [];
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const owners_groups = isArray(_owners_groups) ? _owners_groups : [];

	const { data: integration } = useIntegrationPrefetched({
		id: integrationId!,
		options: { enabled: !!integrationId },
	});
	const forceSourceOwners = !!integration?.force_source_owners;

	const withUserOwners = !isNil(onChangeUserOwners);
	const withUserGroupOwners = !isNil(onChangeGroupOwners);

	const ownerIds = useMemo(() => {
		const userIds =
			owners
				?.map((user) => (typeof user === 'object' ? (user as IUser).id : user))
				.filter((owner) => !isNil(owner)) ?? [];

		const userGroupIds =
			owners_groups
				?.map((group) =>
					typeof group === 'object' ? (group as IUserGroup).id : group
				)
				.filter((owner) => !isNil(owner)) ?? [];

		return [...userIds, ...(withUserGroupOwners ? userGroupIds : [])];
	}, [owners, owners_groups, withUserGroupOwners]);

	const readOnly =
		!(withUserOwners || withUserGroupOwners) ||
		forceSourceOwners ||
		forceReadOnly;

	const handleUserOwnersChange = useCallback(
		(value: string[]) => {
			onChangeUserOwners?.(id)(value);
		},
		[id, onChangeUserOwners]
	);

	const handleGroupOwnersChange = useCallback(
		(value: string[]) => {
			onChangeGroupOwners?.(id)(value);
		},
		[id, onChangeGroupOwners]
	);

	return (
		<PermissionWrapper entity={record} disabled={forceReadOnly}>
			{({ hasPermission }) => {
				// Use lightweight read-only component when user has no edit permissions
				if (
					readOnly ||
					hasPermission !== true ||
					(!onChangeUserOwners && !onChangeGroupOwners)
				) {
					return (
						<OptimizedOwnerRender
							record={record}
							ownerField={field}
							ownerGroupField={ownerGroupField}
							label={label}
							hideOnEmpty={hideOnEmpty}
						/>
					);
				}

				return (
					<Box ml={`-${theme.spacing['2xs']}`}>
						<OwnerSelector
							propertyLabel={label}
							property={field}
							groupUsersBySections={
								members
									? [
											{
												label: 'Current team users',
												value: filter(
													members?.map((membership) => membership?.id) ?? [],
													(el) => !isNil(el)
												),
											},
										]
									: undefined
							}
							forceVariant="tertiary"
							hideOnEmpty={hideOnEmpty}
							initialValue={ownerIds}
							maintainOwners={forceSourceOwners}
							entityIntegrationId={integrationId}
							entityIntegrationName={integration?.name}
							key={ownerIds?.join('-')}
							onChangeUserOwners={handleUserOwnersChange}
							onChangeGroupOwners={handleGroupOwnersChange}
							placeholder={'Add owners'}
							defaultOpened={true}
							position={position}
							withinPortal={withinPortal}
						/>
					</Box>
				);
			}}
		</PermissionWrapper>
	);
}

export function RelatedEntitiesRender<T extends ISecodaEntity>({
	record,
	field = 'related_entities',
	onChange,
	hideOnEmpty = true,
	forceReadOnly = false,
	defaultOpened = false,
}: {
	record: T & { related_entities?: ISecodaEntity[] };
	field?: string;
	onChange?: (entityId: string) => (value: (string | boolean)[]) => void;
	hideOnEmpty?: boolean;
	forceReadOnly?: boolean;
	defaultOpened?: boolean;
}) {
	const readOnly = !onChange || forceReadOnly;

	return (
		<PermissionWrapper entity={record} disabled={forceReadOnly}>
			{({ hasPermission }) => {
				// Use lightweight read-only component when user has no edit permissions
				if (readOnly || hasPermission !== true || !onChange) {
					return (
						<OptimizedRelatedEntitiesRender
							entity={
								record as ISecodaEntity & { related_entities?: ISecodaEntity[] }
							}
							field={field}
							label="resources"
							hideOnEmpty={hideOnEmpty}
						/>
					);
				}

				return (
					<RelatedEntitiesSelector
						entity={
							record as ISecodaEntity & { related_entities?: ISecodaEntity[] }
						}
						field={field}
						onChange={onChange}
						hideOnEmpty={hideOnEmpty}
						defaultOpened={defaultOpened}
					/>
				);
			}}
		</PermissionWrapper>
	);
}

export function RelativeTimeRender<T>({
	record,
	field,
	isFuture = false,
	color = 'text/primary/default',
}: {
	record: T;
	field: string;
	isFuture?: boolean;
	color?: ColorNames;
}) {
	const { classes } = useStyles({});
	const datetimeValue = get(record, field);
	const theme = useMantineTheme();

	if (!datetimeValue) {
		return null;
	}

	const currentTime = dayjs();
	const targetTime = dayjs(datetimeValue);

	if (isFuture && targetTime.isBefore(currentTime)) {
		return null;
	}

	return (
		<Tooltip
			maw={theme.other.space[90]}
			sx={{
				overflowWrap: 'break-word',
				whiteSpace: 'normal',
			}}
			withinPortal
			label={dayjs(datetimeValue).format('YYYY-MM-DD HH:mm:ss')}
		>
			<Text size="sm" className={classes.ellipsis} color={color}>
				{datetimeValue && formatShortTimeDifference(datetimeValue, true)}
			</Text>
		</Tooltip>
	);
}

export function ReadOnlyBadgeRender<T>({
	record,
	field,
	options,
	nilOption,
}: {
	record: T;
	field: string;
	options: {
		variant: BadgeVariant;
		option: string | boolean | number;
		label?: string;
	}[];
	nilOption: {
		variant: BadgeVariant;
		option: string | boolean | number;
		label?: string;
	};
}) {
	function lowerCaseIfString(el: string | boolean | number) {
		return typeof el === 'string' ? lowerCase(el) : el;
	}

	const variant =
		options.find(
			(option) =>
				lowerCaseIfString(option.option) ===
				lowerCaseIfString(get(record, field))
		)?.variant ?? nilOption.variant;

	return (
		<Badge variant={variant}>
			{get(record, field)
				? (
						options.find(
							(option) =>
								lowerCaseIfString(option.option) ===
								lowerCaseIfString(get(record, field))
						)?.label ?? capitalize(get(record, field))
					)?.replace(/_/g, ' ')
				: capitalize(nilOption.label).replace(/_/g, ' ')}
		</Badge>
	);
}

export function IntegrationStatusRender({
	record,
	animate,
}: {
	record: IIntegration;
	animate?: boolean;
}) {
	if (record.type === 'slack' || record.status === 'new') {
		return null;
	}

	return (
		<Group spacing="3xs" noWrap>
			<Icon
				size="md"
				name={INTEGRATION_STATUS_MAPPING[record.status].iconName}
				fillColor={INTEGRATION_STATUS_MAPPING[record.status].iconFillColor}
				color={INTEGRATION_STATUS_MAPPING[record.status].iconColor}
				style={{
					animation: animate ? 'spin 1s linear infinite' : 'none',
				}}
			/>
			<Text size="sm">{INTEGRATION_STATUS_MAPPING[record.status].label}</Text>
		</Group>
	);
}

export function SelectorRender<T extends IBaseModel>({
	record,
	accessor,
	esAccessor,
	nilOption,
	onChange,
	forceReadOnly = false,
}: {
	record: T;
	accessor: string;
	esAccessor?: string;
	nilOption: string | boolean;
	onChange?: (id: string) => (value: string[] | string | boolean) => void;
	forceReadOnly?: boolean;
}) {
	const theme = useMantineTheme();
	const { id } = record;

	const handleChange = useCallback(
		(value: string[] | string | boolean) => {
			onChange?.(id)(value);
		},
		[id, onChange]
	);

	return (
		<PermissionWrapper entity={record} disabled={forceReadOnly}>
			{({ hasPermission }) => {
				// Use optimized read-only component when user doesn't have edit permission
				if (forceReadOnly || isNil(onChange) || hasPermission !== true) {
					return (
						<OptimizedSelectorRender
							record={record}
							accessor={accessor}
							esAccessor={esAccessor}
							nilOption={nilOption}
							hideOnEmpty
						/>
					);
				}

				return (
					<Box ml={`-${theme.spacing['2xs']}`}>
						<SingleSelector
							defaultOpened={true}
							variant="tertiary"
							searchable
							readOnly={false}
							property={accessor}
							placeholder={`No ${accessor}`}
							options={SELECTABLE_PROPERTY_OPTIONS[accessor]}
							onChange={handleChange}
							isViewerUser={false}
							initialSelected={
								(record?.[accessor as keyof T] ??
									record?.[esAccessor as keyof T] ??
									nilOption) as string
							}
							iconType="tabler"
							hideOnEmpty
						/>
					</Box>
				);
			}}
		</PermissionWrapper>
	);
}
interface TeamRenderProps
	extends Partial<Omit<PropertySelectorProps, 'onChange'>> {
	record: {
		id: string;
		teams: ({ id: string } | string)[];
	};
	optionsFilter?: (id: TeamOut) => boolean;
	onChange?: (id: string) => (value: unknown) => void;
	placeholder?: string;
}

export function TeamRender({
	record,
	onChange,
	optionsFilter = () => true,
	...rest
}: TeamRenderProps) {
	const { data } = useApiListTeamsV2({});
	const filteredData = useMemo(
		() => (data || []).filter(optionsFilter),
		[data, optionsFilter]
	);

	return (
		<PropertySelector
			{...rest}
			type="multi"
			value="teams"
			iconType="emoji"
			isViewerUser={isNil(onChange)}
			onChange={onChange?.(record.id)}
			selected={record.teams as string[]}
			returnInheritedValuesOnEmpty={false}
			options={filteredData?.map((team: TeamOut) => ({
				value: team.id,
				label: team.name,
				icon: team.icon,
			}))}
		/>
	);
}

export function CollectionRender<T extends ISecodaEntity>({
	record,
	onChange,
	forceReadOnly = false,
}: {
	record: T;
	onChange?: (id: string) => (value: string[]) => void;
	forceReadOnly?: boolean;
}) {
	const { id, collections } = record;
	const theme = useMantineTheme();

	const collectionIds = useMemo(
		() =>
			collections
				.map((collection) =>
					typeof collection === 'object'
						? (collection as ICollection)?.id
						: collection
				)
				.filter((collection) => !isNil(collection)) as string[],
		[collections]
	);

	const handleChange = useCallback(
		(value: string[]) => {
			onChange?.(id)(value);
		},
		[id, onChange]
	);

	return (
		<PermissionWrapper entity={record} disabled={forceReadOnly}>
			{({ hasPermission }) => {
				// Use lightweight read-only component when user doesn't have edit permission
				if (forceReadOnly || isNil(onChange) || hasPermission !== true) {
					return <OptimizedCollectionRender record={record} hideOnEmpty />;
				}

				// Use full editable component when user has permission
				return (
					<Box ml={`-${theme.spacing['2xs']}`}>
						<CollectionSelector
							key={collectionIds?.join('-')}
							hideOnEmpty
							forceVariant="tertiary"
							onChange={handleChange}
							initialValue={collectionIds}
							readOnly={false}
							placeholder="Add to collection"
							defaultOpened
						/>
					</Box>
				);
			}}
		</PermissionWrapper>
	);
}

const useDescriptionStyles = createStyles(
	(theme, { disabled }: { disabled: boolean }) => {
		const { write } = useTeamPermission();
		return {
			hidden: {
				visibility: 'hidden',
			},
			wrapper: {
				height: `${ROW_HEIGHT - 16}px`,
				marginLeft: `-${theme.spacing.xs}`,
				borderRadius: theme.radius.sm,
				paddingLeft: theme.spacing.xs,
				paddingRight: theme.spacing.xs,
				// Necessary to hide the overflow of the markdown renderer.
				overflow: 'hidden',
				maxWidth: '100%',
				'&:hover': {
					backgroundColor: !write
						? undefined
						: theme.other.getColor('fill/transparent/hover'),
				},
			},
			markdown: {
				lineHeight: `${theme.other.typography.lineHeight.text.xl}`,
				height: `${theme.other.space[7]}px`,
				width: '100%',
				p: {
					lineHeight: `${theme.other.typography.lineHeight.text.xl}`,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				},
			},
			descriptionEditor: {
				backgroundColor: disabled
					? theme.other.getColor('surface/secondary/default')
					: theme.other.getColor('fill/transparent/default'),
				padding: '1rem',
				width: '100%',
				borderRadius: theme.radius.sm,
				border: `${theme.other.space[0.25]}px solid ${theme.other.getColor(
					'border/input/default'
				)}`,
				'&:focus-within, &:focus': {
					outline: '1px solid #0066CC',
				},
			},
			noDescription: {
				color: theme.other.getColor('text/secondary/default'),
			},
		};
	}
);

const NO_WRAP_STYLE: React.CSSProperties = { textWrap: 'nowrap' };

export function DescriptionRender<T extends ISecodaEntity>({
	record,
	label,
	field,
	onChange,
	readOnly = false,
	disableHover = false,
}: {
	record: T;
	field: string;
	label?: string;
	onChange?: (id: string) => (value: string) => void;
	readOnly?: boolean;
	disableHover?: boolean;
}) {
	// eslint-disable-next-line no-param-reassign
	label = label ?? field;
	const { id, integration: integrationId, title } = record;

	// This can include custom properties under the path `properties.custom.` so
	// we must use `get` here.
	const description = get(record, field);

	const { isAdminUser } = useAuthUser();

	const { data: integration } = useIntegrationPrefetched({
		id: integrationId!,
		options: { enabled: !!integrationId },
	});

	const frozenDescription =
		!!integration?.force_source_description &&
		!field.startsWith(CUSTOM_PROPERTY_COLUMN_PREFIX) &&
		!field.startsWith(NEW_CUSTOM_PROPERTY_COLUMN_PREFIX);

	const { classes: descriptionStyles, theme } = useDescriptionStyles({
		disabled: frozenDescription,
	});

	const [inputValue, setInputValue] = useState<string>(description ?? '');
	const [opened, { open, close }] = useDisclosure(true);

	// If an optimistic update is made, we need to update the input value.
	useUpdateEffect(() => {
		setInputValue(description ?? '');
	}, [description]);

	const ref = useRef<string>(description ?? '');
	const descriptionRef = useRef<HTMLDivElement>(null);
	const wrapperRef = useRef<HTMLDivElement>(null);

	const updateRef = useCallback((value: string) => {
		ref.current = value;
	}, []);

	const isEllipsisHidden = useCallback(
		(parent: HTMLDivElement | null, child: HTMLDivElement | null) =>
			parent && child ? parent.offsetWidth - 16 > child.offsetWidth : false,
		[]
	);

	const saveDescription = useCallback(() => {
		setInputValue(ref.current);
		onChange?.(id)(ref.current);
		close();
	}, [id, onChange, close]);

	const handleModal = useCallback(() => {
		if (!onChange) {
			return;
		}
		open();
	}, [onChange, open]);

	return (
		<PermissionWrapper entity={record} disabled={readOnly || !onChange}>
			{({ hasPermission }) => {
				// Use lightweight read-only component when user doesn't have edit permission
				if (readOnly || !onChange || hasPermission !== true) {
					return (
						<OptimizedDescriptionRender
							record={record}
							field={field}
							label={label}
							disableHover={disableHover}
						/>
					);
				}

				// Use full editable component when user has permission
				return (
					<>
						<Modal
							opened={opened}
							onClose={close}
							title={
								<Group spacing="2xs">
									<Text size="md" weight="bold">
										Edit {label} of
									</Text>
									<Text size="md" weight="semibold">
										{title}
									</Text>
								</Group>
							}
							withCloseButton
							closeOnClickOutside
							withinPortal={true}
						>
							<Stack spacing="md">
								<Group className={descriptionStyles.descriptionEditor}>
									{frozenDescription && !inputValue ? (
										<Text
											style={NO_WRAP_STYLE}
											className={descriptionStyles.noDescription}
											color="text/secondary/default"
											size="sm"
										>
											No {label}
										</Text>
									) : (
										<DescriptionEditor
											entityId={id}
											value={inputValue}
											withAi={field === 'description'}
											placeholder={`Add ${label}...`}
											onChange={updateRef}
											save={saveDescription}
											readOnly={frozenDescription}
											autoFocus
										/>
									)}
								</Group>
								{frozenDescription && (
									<Banner
										message={
											isAdminUser ? (
												<Group spacing="xs">
													<Text>
														{description
															? `${capitalize(field)} comes from ${integration?.name}. To maintain in Secoda, go to integration settings.`
															: `No ${label} set in ${integration?.name}. To maintain in Secoda, go to integration settings.`}
													</Text>
													<Link
														to={`/integrations/${integrationId}/preferences`}
													>
														<Button onClick={close}>
															{integration?.name} settings
														</Button>
													</Link>
												</Group>
											) : (
												<Text>Description comes from {integration?.name}.</Text>
											)
										}
										tone="info"
										inCard
									/>
								)}
								{!frozenDescription && (
									<Flex justify="flex-end" gap="md">
										<Button variant="tertiary" onClick={close}>
											Cancel
										</Button>
										<Button onClick={saveDescription}>Save</Button>
									</Flex>
								)}
							</Stack>
						</Modal>
						<Tooltip
							withinPortal
							multiline
							maw={theme.other.space[90]}
							sx={{
								overflowWrap: 'break-word',
								whiteSpace: 'normal',
							}}
							label={inputValue}
							hidden={
								isEmpty(inputValue) ||
								isEllipsisHidden(wrapperRef.current, descriptionRef.current) ||
								disableHover
							}
						>
							<Box
								ref={wrapperRef}
								sx={{
									width: '100%',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<UnstyledButton
									className={descriptionStyles.wrapper}
									onClick={handleModal}
									sx={{
										cursor: 'pointer',
										width: '100%',
										display: 'flex',
										alignItems: 'center',
									}}
								>
									{isEmpty(inputValue) || isNil(inputValue) ? (
										<Text
											style={NO_WRAP_STYLE}
											color="text/secondary/default"
											size="sm"
										>
											{frozenDescription ? `No ${label}` : `Add ${label}`}
										</Text>
									) : (
										<MarkdownRenderer
											ref={descriptionRef}
											className={descriptionStyles.markdown}
											inline
											lineClamp={1}
											fontSize="small"
											ellipsis={true}
										>
											{inputValue}
										</MarkdownRenderer>
									)}
								</UnstyledButton>
							</Box>
						</Tooltip>
					</>
				);
			}}
		</PermissionWrapper>
	);
}

export function PopularityRender({
	record,
}: {
	record: {
		entity_type: string;
		external_usage: number;
		internal_usage: number;
	};
}) {
	const theme = useMantineTheme();
	const {
		entity_type: entityType,
		external_usage: externalUsage,
		internal_usage: internalUsage,
	} = record;

	const hasExternalUsage = !isNil(externalUsage) && externalUsage > 0;
	const usage = hasExternalUsage ? externalUsage : internalUsage;

	if (isNil(usage) || usage === 0) {
		return null;
	}

	if (entityType === EntityType.column) {
		return null;
	}

	return (
		<Group spacing={theme.spacing.xs}>
			<Popularity level={Math.log10(usage)} />
			<Text size="sm" color="text/primary/default">
				{nFormatter(usage, 1)}{' '}
				{entityType === EntityType.table && hasExternalUsage
					? 'queries'
					: 'views'}
			</Text>
		</Group>
	);
}

export function RenderWithMonitorTypeAndIntegrationLogo({
	displayMetadata,
	metricType,
	onClick = undefined,
}: {
	metricType: string;
	displayMetadata: {
		label?: string;
		target?: {
			integration?: string;
			target_title?: string;
			target_url?: string;
			integration_name?: string;
			integration_url?: string;
			label?: string;
			integration_type?: string;
			integration_metric?: string;
		};
	};
	onClick?: () => void;
}) {
	const { classes, theme } = useStyles({});

	const handleClick = useCallback(
		(e: React.MouseEvent) => {
			if (onClick) {
				e.preventDefault();
				e.stopPropagation();
				onClick();
			}
		},
		[onClick]
	);

	const mt = capitalize(metricType?.replace('_', ' '));

	const monitorType = displayMetadata?.target?.integration_type
		? {
				metric_type: metricType as MetricType,
				integration_type: displayMetadata.target
					.integration_type as AnalyticsMetricType,
			}
		: { metric_type: metricType as MetricType };

	return (
		<Group noWrap>
			<MonitorIcon type={monitorType} />
			<Flex
				direction="column"
				justify="center"
				my={theme.spacing.sm}
				onClick={handleClick}
				style={{ minWidth: 0 }}
			>
				<Text
					weight="bold"
					size="sm"
					sx={{
						lineHeight: `${theme.other.space[4]}px`,
					}}
					className={classes.ellipsis}
				>
					{displayMetadata?.label ?? ''}
				</Text>
				<Text
					size="xs"
					color="text/secondary/default"
					sx={{
						lineHeight: `${theme.other.space[4]}px`,
					}}
					className={classes.ellipsis}
				>
					{`${mt} · ${displayMetadata?.target?.integration_name ?? ''}`}
				</Text>
			</Flex>
		</Group>
	);
}

export function RenderWithIntegrationLogo({
	textContent,
	integrationType,
	integrationId,
	forceTitleCase = true,
	onClick = undefined,
}: {
	textContent?: string;
	integrationType?: string;
	integrationId?: string;
	forceTitleCase?: boolean;
	onClick?: () => void;
}) {
	const { classes, theme } = useStyles({});

	const handleClick = useCallback(
		(e: React.MouseEvent) => {
			if (onClick) {
				e.preventDefault();
				e.stopPropagation();
				onClick();
			}
		},
		[onClick]
	);

	return (
		<Group
			display="flex"
			noWrap
			spacing={theme.spacing.xs}
			onClick={handleClick}
		>
			<IntegrationLogo
				integrationId={integrationId}
				integrationType={integrationType}
				width={theme.other.space[4]}
				height={theme.other.space[4]}
			/>
			<Text
				size="sm"
				sx={{
					lineHeight: `${theme.other.space[4]}px`,
				}}
				className={classes.ellipsis}
			>
				{forceTitleCase
					? snakeCaseToTitleCase(textContent ?? '')
					: (textContent ?? '')}
			</Text>
		</Group>
	);
}

export function IntegrationRender({
	record,
}: {
	record: { integration: string };
}) {
	const { integration: integrationId } = record;
	const { data: integration } = useIntegrationPrefetched({ id: integrationId });

	if (!integration) {
		return null;
	}

	return (
		<RenderWithIntegrationLogo
			integrationId={integrationId}
			integrationType={integration.type}
			textContent={integration.name}
		/>
	);
}

export function MonitorResourceRenderV2({
	record,
}: {
	record: {
		metric_type?: string;
		target?: string;
		display_metadata?: {
			label?: string;
			target?: {
				integration?: string;
				target_title?: string;
				target_url?: string;
				integration_name?: string;
				integration_url?: string;
				label?: string;
				integration_type?: string;
			};
		};
	};
}) {
	return (
		<RenderWithMonitorTypeAndIntegrationLogo
			metricType={record.metric_type ?? ''}
			displayMetadata={record.display_metadata ?? {}}
		/>
	);
}

export function MonitorResourceRender({
	record,
}: {
	record: {
		target?: string;
		display_metadata?: {
			target?: {
				integration?: string;
				target_title?: string;
				target_url?: string;
				integration_name?: string;
				integration_url?: string;
				label?: string;
				integration_type?: string;
			};
		};
	};
}) {
	const navigate = useNavigate();
	const dm = record.display_metadata?.target || {};

	if (record.target) {
		return (
			<RenderWithIntegrationLogo
				forceTitleCase={false}
				integrationType={dm.integration_type ?? ''}
				textContent={dm.target_title ?? ''}
			/>
		);
	} else {
		return (
			<RenderWithIntegrationLogo
				forceTitleCase={false}
				integrationType={dm.integration_type ?? ''}
				textContent={dm.integration_name ?? ''}
			/>
		);
	}
}

export function PiiIntegrationRender(record: {
	integration_name: string;
	integration_id: string;
}) {
	return (
		<RenderWithIntegrationLogo
			integrationType={record.integration_name ?? ''}
			integrationId={record.integration_id ?? ''}
			textContent={record.integration_name ?? ''}
		/>
	);
}

export function QueryResourceRender(record: {
	related_entities?: {
		id?: string | null | undefined;
		integration_id?: string | null | undefined;
		title_full?: string | null | undefined;
		title?: string | null | undefined;
		entity_type?: string | null | undefined;
	}[];
}) {
	return (
		<StaticProperty
			label={`${record.related_entities?.length ?? 0} Resources`}
			value={
				(record.related_entities || []).map((entity) => ({
					label: entity.title_full || entity.title,
					value: entity.id,
					icon: (
						<IntegrationLogo
							height={18}
							width={18}
							entityType={(entity?.entity_type as EntityType) ?? ''}
							integrationId={entity?.integration_id ?? ''}
						/>
					),
				})) as SelectablePropertyItem[]
			}
			type="tables"
			forceInline
		/>
	);
}

function DateRender({ value }: { value: string | undefined }) {
	return <DateRenderer value={value} size="sm" />;
}

export function CreatedAtRender({
	record,
}: {
	record: { created_at?: string | undefined };
}) {
	return <DateRender value={record?.created_at} />;
}

const useSqlRenderStyles = createStyles((theme) => ({
	prismRoot: {
		backgroundColor: theme.other.getColor('surface/secondary/default'),
		borderRadius: 8,
		padding: 5,
	},
	prismScrollArea: {
		backgroundColor: 'transparent',
		marginRight: 5,
	},
	prismCode: {
		backgroundColor: 'transparent !important',
		minHeight: 90,
		'text-wrap': 'balance',
	},
}));

export function SQLRender(record: { sql?: string | undefined | null }) {
	const { classes } = useSqlRenderStyles();

	// Only render first 100 characters of the SQL query
	const sql = record.sql || '';

	const truncatedSql = sql.length > 100 ? `${sql.slice(0, 100)}...` : sql;

	return (
		<RichTooltip
			title="SQL"
			withinPortal
			body={
				<Box
					onClick={(e) => {
						e.stopPropagation();
					}}
				>
					<Prism
						classNames={{
							root: classes.prismRoot,
							code: classes.prismCode,
							scrollArea: classes.prismScrollArea,
						}}
						language="sql"
						trim
					>
						{sql}
					</Prism>
				</Box>
			}
		>
			<Text size="sm" truncate>
				{truncatedSql}
			</Text>
		</RichTooltip>
	);
}

export function CostRender({
	record,
}: {
	record: {
		estimated_cost?: number | undefined | null;
	};
}) {
	const { estimated_cost } = record;

	return (
		<Text size="sm" color="text/primary/default">
			{estimated_cost ? `$${estimated_cost.toFixed(2)}` : 'N/A'}
		</Text>
	);
}

export function RuntimeRender({
	record,
}: {
	record: { runtime?: number | undefined | null };
}) {
	const { runtime } = record;

	return (
		<Text size="sm" color="text/primary/default">{`${runtime || 0} ms`}</Text>
	);
}

export function LastUpdatedRender<T>({
	record,
	field,
}: {
	record: T;
	field: keyof T;
}) {
	return <DateRender value={get(record, field)} />;
}

export function DurationRender<T>({
	record,
	field1,
	field2,
}: {
	record: T;
	field1: keyof T;
	field2: keyof T;
}) {
	const { classes } = useStyles({});

	const createdAt = get(record, field1);
	const finishedAt = get(record, field2);

	if (createdAt && finishedAt) {
		const durationSeconds = Math.abs(
			getEpoch(createdAt) - getEpoch(finishedAt)
		);

		const minutes = Math.floor(durationSeconds / 60);
		const seconds = durationSeconds % 60;

		return (
			<Text
				role="link"
				size="sm"
				sx={{
					lineHeight: `${ROW_HEIGHT}px`,
				}}
				className={classes.ellipsis}
				color="text/primary/default"
			>
				{`${minutes > 0 ? `${minutes}m` : ''} ${seconds}s`}
			</Text>
		);
	}

	return null;
}

export function SQLTitleRender(record: {
	title?: string | undefined | null;
	dialect?: string | undefined | null;
}) {
	const { classes } = useStyles({});
	const queryTitle = capitalize(record.title || `${record.dialect} Query`);

	return (
		<Text
			size="sm"
			sx={{
				lineHeight: `${ROW_HEIGHT}px`,
			}}
			className={classes.ellipsis}
			color="text/primary/default"
			fw={600}
		>
			{queryTitle}
		</Text>
	);
}

export function DataQualityRender<T>({
	record,
}: {
	record: T & { dqs?: DataQualityScore };
}) {
	const ref = useRef<HTMLDivElement>(null);

	return <DataQualityBadgeWithHover dqs={record?.dqs} ref={ref} />;
}

export function TotalRunTimeRender(record: {
	total_runtime?: number | undefined | null;
}) {
	const { total_runtime } = record;

	const textWithUnit = useMemo(() => {
		if (total_runtime) {
			if (total_runtime < 1000) {
				return `${total_runtime.toFixed(0)} ms`;
			} else if (total_runtime < 60000) {
				return `${(total_runtime / 1000).toFixed(0)} s`;
			} else if (total_runtime < 3600000) {
				return `${(total_runtime / 60000).toFixed(2)} min`;
			} else {
				return `${(total_runtime / 3600000).toFixed(2)} h`;
			}
		}

		return 'N/A';
	}, [total_runtime]);

	return (
		<Text size="sm" color="text/primary/default">
			{textWithUnit}
		</Text>
	);
}

export function AverageRunTimeRender(record: {
	average_runtime?: number | undefined | null;
}) {
	const { average_runtime } = record;

	const textWithUnit = useMemo(() => {
		if (average_runtime) {
			if (average_runtime < 1000) {
				return `${average_runtime.toFixed(0)} ms`;
			} else if (average_runtime < 60000) {
				return `${(average_runtime / 1000).toFixed(0)} s`;
			} else {
				return `${(average_runtime / 60000).toFixed(2)} min`;
			}
		}

		return 'N/A';
	}, [average_runtime]);

	return (
		<Text size="sm" color="text/primary/default">
			{textWithUnit}
		</Text>
	);
}

export function LastExecutionRender(record: {
	last_execution_at?: string | undefined | null;
}) {
	return <DateRender value={record.last_execution_at ?? undefined} />;
}

export function TotalRunsRender(record: {
	total_runs?: number | undefined | null;
}) {
	const { total_runs } = record;

	const textWithUnit = useMemo(() => {
		if (total_runs) {
			return `${total_runs}`;
		}

		return 'N/A';
	}, [total_runs]);

	return (
		<Text size="sm" color="text/primary/default">
			{textWithUnit}
		</Text>
	);
}

export function ReadOnlyQueryFrequentUsersRender(record: {
	frequent_users?: LiteUser[] | undefined | null;
	showTooltip?: boolean;
}) {
	if (!record.frequent_users) {
		return null;
	}

	const { frequent_users } = record;
	return (
		<ReadOnlyOwnersRender
			owners={frequent_users as unknown as IUser[]}
			showTooltip={record.showTooltip}
		/>
	);
}

export function DateTimeRender({
	record,
	field,
}: {
	record: Automation | PolicyOut;
	field: string;
}) {
	const datetimeValue = get(record, field);
	const status = get(record, 'status');
	const enabled = get(record, 'enabled');

	if (
		!datetimeValue ||
		(status === 'disabled' && field === 'next_run_at') ||
		(enabled === false && field === 'last_run_at')
	) {
		return <Icon name="lineDashed" color="icon/secondary/default" />;
	}

	return (
		<Text size="sm" style={{ whiteSpace: 'nowrap' }}>
			{dayjs(datetimeValue).format('MMM D, YYYY [at] h:mm A')}
		</Text>
	);
}

export function SynonymsRender({
	synonyms,
	onChange,
}: {
	synonyms: Array<string> | undefined | null;
	onChange?: (value: Array<string>) => void;
}) {
	return <SynonymsSelector synonyms={synonyms ?? []} onChange={onChange} />;
}

export function DatePickerRender<T extends ISecodaEntity>({
	record,
	field,
	label,
	onChange,
	readOnly = false,
}: {
	record: T;
	field: string;
	label?: string;
	onChange?: (id: string) => (value: string) => void;
	readOnly?: boolean;
}) {
	// eslint-disable-next-line no-param-reassign
	label = label ?? field;
	const { id, title } = record;
	const value = get(record, field) as DateValue;

	const { classes: descriptionStyles } = useDescriptionStyles({
		disabled: readOnly,
	});

	const localValueRef = useRef(dayjs(value).toDate() as DateValue);
	const [displayValue, setDisplayValue] = useState(
		dayjs(value).toDate() as DateValue
	);
	const [opened, { open, close }] = useDisclosure(true);

	// If an optimistic update is made, we need to update the display value.
	useUpdateEffect(() => {
		setDisplayValue(dayjs(value).toDate() as DateValue);
	}, [value]);

	const handleSave = useCallback(() => {
		setDisplayValue(localValueRef.current);
		onChange?.(id)(localValueRef.current?.toISOString() ?? '');
		close();
	}, [id, localValueRef, onChange, close]);

	const handleModal = useCallback(() => {
		if (!onChange) return;
		open();
	}, [onChange, open]);

	return (
		<PermissionWrapper entity={record} disabled={readOnly || !onChange}>
			{({ hasPermission }) => {
				// Use lightweight read-only component when user doesn't have edit permission
				if (readOnly || !onChange || hasPermission !== true) {
					return (
						<OptimizedDatePickerRender
							record={record}
							field={field}
							label={label}
						/>
					);
				}

				// Use full editable component when user has permission
				return (
					<>
						<Modal
							opened={opened}
							onClose={close}
							title={
								<Group spacing="2xs">
									<Text size="md" weight="bold">
										Edit {label} of
									</Text>
									<Text size="md" weight="semibold">
										{title}
									</Text>
								</Group>
							}
							withCloseButton
							closeOnClickOutside
							withinPortal={true}
						>
							<Stack spacing="md">
								<DatePicker
									defaultValue={displayValue}
									onChange={(newValue) => {
										newValue && (localValueRef.current = newValue);
									}}
									autoFocus
								/>
								<Flex justify="flex-end" gap="md">
									<Button variant="tertiary" onClick={close}>
										Cancel
									</Button>
									<Button onClick={handleSave}>Save</Button>
								</Flex>
							</Stack>
						</Modal>
						<UnstyledButton
							className={descriptionStyles.wrapper}
							onClick={handleModal}
							sx={{
								cursor: 'pointer',
								width: '100%',
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<Text
								style={NO_WRAP_STYLE}
								className={descriptionStyles.markdown}
								size="sm"
							>
								{dayjs(displayValue).format('MMM D, YYYY')}
							</Text>
						</UnstyledButton>
					</>
				);
			}}
		</PermissionWrapper>
	);
}

export function NumberRender<T extends ISecodaEntity>({
	record,
	field,
	label,
	onChange,
	readOnly = false,
}: {
	record: T;
	field: string;
	label?: string;
	onChange?: (id: string) => (value: number) => void;
	readOnly?: boolean;
}) {
	// eslint-disable-next-line no-param-reassign
	label = label ?? field;
	const { id, title } = record;
	const value = get(record, field) as number;

	const { classes: descriptionStyles } = useDescriptionStyles({
		disabled: readOnly,
	});

	const localValueRef = useRef(value);
	const [displayValue, setDisplayValue] = useState(value);
	const [opened, { open, close }] = useDisclosure(true);

	// If an optimistic update is made, we need to update the display value.
	useUpdateEffect(() => {
		setDisplayValue(value);
	}, [value]);

	const handleSave = useCallback(() => {
		setDisplayValue(localValueRef.current);
		onChange?.(id)(localValueRef.current);
		close();
	}, [id, localValueRef, onChange, close]);

	const handleModal = useCallback(() => {
		if (!onChange) return;
		open();
	}, [onChange, open]);

	return (
		<PermissionWrapper entity={record} disabled={readOnly || !onChange}>
			{({ hasPermission }) => {
				// Use lightweight read-only component when user doesn't have edit permission
				if (readOnly || !onChange || hasPermission !== true) {
					return (
						<OptimizedNumberRender
							record={record}
							field={field}
							label={label}
						/>
					);
				}

				// Use full editable component when user has permission
				return (
					<>
						<Modal
							opened={opened}
							onClose={close}
							title={
								<Group spacing="2xs">
									<Text size="md" weight="bold">
										Edit {label} of
									</Text>
									<Text size="md" weight="semibold">
										{title}
									</Text>
								</Group>
							}
							withCloseButton
							closeOnClickOutside
							withinPortal={true}
						>
							<Stack spacing="md">
								<NumberInput
									label={label}
									defaultValue={displayValue}
									onChange={(newValue: number | undefined) => {
										newValue && (localValueRef.current = newValue);
									}}
									autoFocus
								/>
								<Flex justify="flex-end" gap="md">
									<Button variant="tertiary" onClick={close}>
										Cancel
									</Button>
									<Button onClick={handleSave}>Save</Button>
								</Flex>
							</Stack>
						</Modal>
						<UnstyledButton
							className={descriptionStyles.wrapper}
							onClick={handleModal}
							sx={{
								cursor: 'pointer',
								width: '100%',
								display: 'flex',
								alignItems: 'center',
							}}
						>
							{isNil(displayValue) ? (
								<Text
									style={NO_WRAP_STYLE}
									color="text/secondary/default"
									size="sm"
								>
									Add {label}
								</Text>
							) : (
								<Text
									style={NO_WRAP_STYLE}
									className={descriptionStyles.markdown}
									size="sm"
								>
									{displayValue}
								</Text>
							)}
						</UnstyledButton>
					</>
				);
			}}
		</PermissionWrapper>
	);
}

export function JoinTypeRender(record: {
	join_method: JoinMethod;
	join_side: JoinSide;
	join_kind: JoinKind;
}) {
	const { join_method, join_side, join_kind } = record;

	let type = '';

	if (join_method !== 'NONE') {
		type += join_method + ' ';
	}
	if (join_side !== 'NONE') {
		type += join_side + ' ';
	}
	if (join_kind !== 'NONE') {
		type += join_kind + ' ';
	}

	type += 'JOIN';

	return <Text size="xs">{type}</Text>;
}

export function JoinOperatorRender(record: {
	operator: JoinConditionOperator;
}) {
	const { operator } = record;
	const operatorMap = {
		EQ: '=',
		NEQ: '!=',
		NULLSAFE_EQ: 'IS',
		GT: '>',
		GTE: '>=',
		LT: '<',
		LTE: '<=',
	};
	return <Text weight="bold">{operatorMap[operator]}</Text>;
}
